<template>
    <div class="flex justify-center" :id="'message'-message.id">
       <div>
           <div v-for="item in messageArray" class="message-box bg-orange-50 border-2 border-orange-100 px-2 py-1 font-medium" :id="'message-'+message.id">
               <div class="text-center text-sm" v-html="item"></div>
           </div>
       </div>
    </div>
</template>

<script>
import "../../../css/messaging.css";

export default {
    name: "SystemMessage",
    props: ["message"],

    created () {
        this.formatSystemMessage();
    },

    data () {
        return {
            messageArray: [],

        };
    },

    methods: {
        formatSystemMessage () {
            this.messageArray = this.message.message.split(",");
        }
    }
};
</script>

<style scoped>

</style>
